<div class="transfer-call-form">
  <!-- Header row with labels only -->
  <div class="row row-gutters">
    <div class="col col-xs-12 col-sm-4">
      <glxy-form-field [required]="true">
        <glxy-label id="phone-number-label">{{
          'AI_ASSISTANT.SETTINGS.TRANSFER_CALL.PHONE_NUMBER.LABEL' | translate
        }}</glxy-label>
      </glxy-form-field>
    </div>
    <div class="col col-xs-12 col-sm-7">
      <glxy-form-field [required]="true">
        <glxy-label id="criteria-label">{{
          'AI_ASSISTANT.SETTINGS.TRANSFER_CALL.CRITERIA.LABEL' | translate
        }}</glxy-label>
      </glxy-form-field>
    </div>
    <div class="col col-xs-12 col-sm-1"></div>
  </div>

  <!-- Form rows with inputs only -->
  @for (entryForm of transferCallFormArray.controls; track $index) {
    <div class="row row-gutters align-items-center" [formGroup]="entryForm">
      <div class="col col-xs-12 col-sm-4">
        <glxy-form-field prefixIcon="phone" [hideRequiredLabel]="true">
          <input
            matInput
            type="tel"
            formControlName="number"
            aria-labelledby="phone-number-label"
            placeholder="{{ 'AI_ASSISTANT.SETTINGS.TRANSFER_CALL.PHONE_NUMBER.PLACEHOLDER' | translate }}"
          />
          @if (getFieldErrorKey(entryForm.get('number')!, 'number'); as errorKey) {
            <glxy-error>{{ errorKey | translate }}</glxy-error>
          }
        </glxy-form-field>
      </div>

      <div class="col col-xs-12 col-sm-7">
        <glxy-form-field [hideRequiredLabel]="true">
          <input
            matInput
            type="text"
            formControlName="criteria"
            aria-labelledby="criteria-label"
            placeholder="{{ 'AI_ASSISTANT.SETTINGS.TRANSFER_CALL.CRITERIA.PLACEHOLDER' | translate }}"
          />
          @if (getFieldErrorKey(entryForm.get('criteria')!, 'criteria'); as errorKey) {
            <glxy-error>{{ errorKey | translate }}</glxy-error>
          }
        </glxy-form-field>
      </div>

      <div class="col col-xs-12 col-sm-1 d-flex justify-content-start">
        @if (transferCallFormArray.length > 1) {
          <button
            mat-icon-button
            type="button"
            [disabled]="configurationForm().disabled"
            (click)="removeTransferCallEntry($index)"
            class="remove-button"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    </div>
  }

  <div class="add-entry-section">
    <button
      mat-button
      type="button"
      [disabled]="configurationForm().disabled"
      (click)="addTransferCallEntry()"
      class="add-button"
      color="primary"
    >
      + {{ 'AI_ASSISTANT.SETTINGS.TRANSFER_CALL.ADD_NUMBER' | translate }}
    </button>
  </div>
</div>
